<template>
  <q-layout view="hHh Lpr fFf">
    <q-page-container>
      <el-row>
        <el-col>
          <h4>上海屿倩商贸有限公司ERP系统</h4>
        </el-col>
      </el-row>
      <el-form
        id="components-form-demo-normal-login"
        :model="form"
        class="login-form"
        :rules="rules"
        ref="form"
      >
        <el-form-item>
          <h5>登录</h5>
        </el-form-item>
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="密码"
            @keyup.enter.native="handleSubmit('form')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="form.rememberMe">记住我</el-checkbox>
          <!-- <a class="login-form-forgot" href>Forgot password</a> -->
          <el-button
            type="primary"
            @click="handleSubmit('form')"
            class="login-form-button"
            >登 录</el-button
          >
          <!-- Or
        <a href>register now!</a>-->
        </el-form-item>
      </el-form>
    </q-page-container>

    <q-footer elevated class="bg-grey-8 text-white">
      <q-toolbar>
        <q-toolbar-title style="text-align: center; text-font: 16px">
          上海屿倩商贸有限公司
          <a
            href="https://beian.miit.gov.cn"
            style="font-size: 15px; color: white"
            >沪ICP备2021017912号-1</a
          >
        </q-toolbar-title>
      </q-toolbar>
    </q-footer>
  </q-layout>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      form: {
        username: "",
        password: "",
        rememberMe: false,
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入用密码", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getCookie();
  },
  methods: {
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      this.form = {
        username: username === undefined ? this.form.username : username,
        password: password === undefined ? this.form.password : password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
      };
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.rememberMe) {
            Cookies.set("username", this.form.username, { expires: 30 });
            Cookies.set("password", this.form.password, { expires: 30 });
            Cookies.set("rememberMe", this.form.rememberMe, { expires: 30 });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
          }

          var self = this;
          const headers = {
            Authorization: "Basic Y2xpZW50OnNlY3JldA==",
          };
          self.form.grant_type = "password";
          //多类型登陆
          let loginParams = JSON.parse(JSON.stringify(self.form));
          let username = { type: "username", username: loginParams.username };
          loginParams.username = JSON.stringify(username);

          this.$axios
            .get("oauth/token", { headers: headers, params: loginParams })
            .then(function (response) {
              if (response.status == "200") {
                self.$message({
                  message: "登录成功",
                  type: "success",
                });
                self.$store.commit("setToken", response.data.access_token);
                const curr = localStorage.getItem("preRoute");
                if (curr == null) {
                  self.$router.push("/");
                } else {
                  self.$router.push({ path: curr });
                }
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-form {
  max-width: 400px;
  width: 350px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  padding: 30px 35px 15px;
  margin: 0 auto;
  margin-top: 50px;
}
.login-form-forgot {
  float: right;
}
.login-form-button {
  width: 100%;
}
h5 {
  text-align: center;
  font-weight: bold;
}
h4 {
  margin-top: 150px;
  text-align: center;
}
a {
  text-decoration: none;
}
</style>